import React, { Component } from 'react';
import {
  PreferitsMenuIconBtn,
  PreferitsContainer,
  PreferitsMenuIconWrapper,
  PreferitsListContainer,
  PreferitsFooterButton,
  PreferitsIconNumber,
  PreferitsListWrapper
} from './PreferitsElement';
import PreferitsCard from './PreferitsCard';
import { getTranslatedKey } from '../Utils/TranslateUtils';

export default class Preferits extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <PreferitsContainer alturaBtnFav={this.props.alturaBtnFav}>
        <PreferitsMenuIconWrapper title={getTranslatedKey('fav')} onClick={() => this.props.onFavClick(!this.props.favOpen)}>
          <PreferitsMenuIconBtn open={this.props.favOpen}>
            <svg xmlns="http://www.w3.org/2000/svg" id="ICON" fill={this.props.favOpen ? 'black' : 'white'} viewBox="0 0 32 32" width="30">
              <path d="m7.998 30.544c-.415 0-.827-.129-1.176-.382-.589-.428-.899-1.143-.809-1.866l.98-7.839-5.399-5.766c-.498-.532-.668-1.293-.442-1.986.225-.692.81-1.208 1.524-1.345l7.759-1.49 3.813-6.918c.353-.638 1.023-1.035 1.752-1.035s1.399.396 1.751 1.034 3.814 6.918 3.814 6.918l7.758 1.49c.715.137 1.3.653 1.524 1.345.226.693.056 1.454-.441 1.986l-5.401 5.766.98 7.839c.091.723-.22 1.438-.809 1.866-.591.429-1.366.501-2.025.192l-7.152-3.354-7.152 3.354c-.271.127-.561.189-.85.189zm7.999-26.631-3.812 6.923c-.288.521-.788.885-1.373.998l-7.76 1.49 5.4 5.766c.408.436.6 1.024.525 1.616l-.98 7.838 7.152-3.354c.542-.253 1.16-.252 1.698 0l7.153 3.355-.98-7.839c-.074-.591.117-1.18.525-1.615l5.4-5.766-7.759-1.49c-.586-.113-1.086-.477-1.374-.998l-3.817-6.923z" />
            </svg>
          </PreferitsMenuIconBtn>
          <PreferitsIconNumber>{this.props.favList.length}</PreferitsIconNumber>
        </PreferitsMenuIconWrapper>
        {this.props.favOpen && (
          <PreferitsListWrapper altura={this.props.alturaBtnFav}>
            <PreferitsListContainer altura={this.props.alturaBtnFav}>
              {this.props.favList.map((fav) => {
                return (
                  <PreferitsCard
                    onClickMap={this.props.onClickMap}
                    fontSizeEnabled={this.props.fontSizeEnabled}
                    deleteFav={this.props.deleteFav}
                    goToFavFeature={this.props.goToFavFeature}
                    featureOverlay={this.props.featureOverlay}
                    map={this.props.map}
                    alturaInfoPunt={this.props.alturaInfoPunt}
                    fav={fav}
                  />
                );
              })}
            </PreferitsListContainer>
            <PreferitsFooterButton title={getTranslatedKey('favClear')} onClick={this.props.clearFav}>
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 512 512" width="22" fill="white">
                <path
                  xmlns="http://www.w3.org/2000/svg"
                  fill-rule="evenodd"
                  d="M100,0h312c55.2,0.1,99.9,44.8,100,100v312c-0.1,55.2-44.8,99.9-100,100H100C44.8,511.9,0.1,467.2,0,412V100  C0.1,44.8,44.8,0.1,100,0z M141.7,443.1c-8.5,0-15.8-3-21.9-9.1c-6.1-6.1-9.1-13.4-9.1-21.9V117.5H89.5v-31h97.2V71h136.5v15.5h97.2  v31h-21.2v294.6c0,8.3-3.1,15.5-9.3,21.7c-6.2,6.2-13.4,9.3-21.7,9.3H141.7z M368.1,117.5H141.7v294.6h226.4V117.5z M196.5,367.7h31  V161.4h-31V367.7z M282.3,367.7h31V161.4h-31V367.7z M141.7,117.5v294.6V117.5z"></path>
              </svg>
            </PreferitsFooterButton>
          </PreferitsListWrapper>
        )}
      </PreferitsContainer>
    );
  }
}
